module.exports = __webpack_public_path__ + "static/img/15.41b5b91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/15.jpg
// module id = yCaq
// module chunks = 1